import React from "react";
import { Col, Layout, Row, Space, Spin, Typography } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ICaseLawDocumentListPresenter } from "../../presenter/CaseLawDocumentListPresenter";
import CaseLawDocumentList from "../components/CaseLawDocumentList";
import SearchCriteriaForm from "../../../search/ui/components/SearchCriteriaForm";
const { Content, Sider } = Layout;
const { Title } = Typography;

export interface Props extends PageProps {}

export interface State extends ICaseLawDocumentListPresenter {}

export default class CaseLawDocumentListPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      caseLawDocuments,
      organisations,
      loaders,
      createNewCaseLawDocument,
      showCaseLawDocumentDetails,
      user,
      application
    } = this.state;
    return (
      <Page {...this.props}>
        {
          <Spin spinning={this.state.loaders.caseLawDocumentLoader}>
            <Layout>
              <Sider
                className={"content-container dashboard-sider search-sider"}
                breakpoint="xl"
                collapsible
                collapsedWidth="0"
                width={"22%"}
              >
                <SearchCriteriaForm
                  user={user}
                  translate={translate}
                  organisations={organisations}
                  showStatusFilter={!application.isPortal()}
                />
              </Sider>
              <Layout className={"dashboard-content-wrapper"}>
                <Content className="site-layout-background dashboard-content-container">
                  <Row gutter={[0, 16]}>
                    <Col xs={24} sm={24}>
                      <Space size={"large"} align="center">
                        <Title level={1}>
                          {translate(
                            "editors.case_law_documents.case_law_document"
                          )}
                        </Title>
                      </Space>
                    </Col>
                  </Row>
                  <CaseLawDocumentList
                    translate={translate}
                    loaders={loaders}
                    caseLawDocumentList={caseLawDocuments}
                    createNewCaseLawDocument={createNewCaseLawDocument}
                    showCaseLawDocumentDetails={showCaseLawDocumentDetails}
                    user={user}
                    showSearchResult={false}
                  />
                </Content>
              </Layout>
            </Layout>
          </Spin>
        }
      </Page>
    );
  }
}
